import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Alert, AlertTitle } from "@material-ui/lab";
import spreadsheet from "../../images/spreadsheet.png";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export default function QuestionsSpreadsheet() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading} component="h3">
            <b>Import file example.</b>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Alert severity="success">
            <AlertTitle>Sample Import</AlertTitle>
            Here's a glimpse at what an import file might look like. Remember to
            add a header for first line, otherwise first question will be
            skiped. The order of questions will be based on the order they are
            imported.
            <Box m={1.5} display="flex" justifyContent="center">
              <img src={spreadsheet} alt="Trivia Questions Import File" />
            </Box>
          </Alert>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
